import { ErrorMessage } from "lib-core"

export { ErrorMessage }
export default ErrorMessage
